import { render, staticRenderFns } from "./DyPluginStatus.vue?vue&type=template&id=31147ac4&scoped=true"
import script from "./DyPluginStatus.vue?vue&type=script&lang=js"
export * from "./DyPluginStatus.vue?vue&type=script&lang=js"
import style0 from "./DyPluginStatus.vue?vue&type=style&index=0&id=31147ac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31147ac4",
  null
  
)

export default component.exports